import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as DoorAccessActionCreators from '../../../actions/doorAccess'

import UnitGrantDoorAccessDialog from './UnitGrantDoorAccessDialog'
import DoorAccessFormDialog from '../DoorAccessFormDialogContainer'

import { getDoorAccessesByCommunityId } from '../../../utils/DoorAccesses'

const SUBMIT_BUTTON_LABEL_ADD = 'Add to Unit'
const SUBMIT_BUTTON_LABEL_CREATE = 'Create & Add to Unit'
const DEFAULT_STATE = {
  isCreateNew: false,
  isFormValid: false,
  accessId: null,
  doorAccessName: '',
  openDoorAccessDialog: false,
}

class UnitGrantDoorAccessDialogContainer extends React.Component {
  static propTypes = {
    /* passed props */
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    unit: PropTypes.object.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  state = DEFAULT_STATE

  onClose = () => {
    this.setState(DEFAULT_STATE)
    this.props.onClose()
  }

  onSuggestionSelected = (suggestion) => {
    if (suggestion) {
      this.setState({
        accessId: suggestion.id,
        doorAccessName: suggestion.name,
        isCreateNew: Boolean(suggestion.isCreateNew),
        isFormValid: true,
      })
    } else {
      this.setState(DEFAULT_STATE)
    }
  }

  onSubmit = () => {
    if (this.state.isCreateNew) {
      this.setState({ openDoorAccessDialog: true })
    } else {
      this.props.doorAccessActions.addUnitDoorAccesses(
        [this.props.unit.id],
        [this.state.accessId],
      )
      this.onClose()
    }
  }

  handleDoorAccessDialogClose = () => {
    this.onClose()
  }

  render() {
    const { doorAccesses, unit } = this.props
    const communityId = unit.community_id
    const communityDoorAccesses = getDoorAccessesByCommunityId(doorAccesses, communityId)

    return (
      <>
        <UnitGrantDoorAccessDialog
          doorAccesses={Object.values(communityDoorAccesses)}
          isFormValid={this.state.isFormValid}
          open={this.props.open}
          onClose={this.onClose}
          onSubmit={this.onSubmit}
          onSuggestionSelected={this.onSuggestionSelected}
          submitButtonLabel={this.state.isCreateNew ? SUBMIT_BUTTON_LABEL_CREATE : SUBMIT_BUTTON_LABEL_ADD}
          unitName={this.props.unit.name}
        />

        <DoorAccessFormDialog
          communityId={communityId}
          name={this.state.doorAccessName}
          onClose={this.handleDoorAccessDialogClose}
          open={this.state.openDoorAccessDialog}
          unitId={unit.id}
        />
      </>
    )
  }
}

export default connect(
  UnitGrantDoorAccessDialogContainer.mapStateToProps,
  UnitGrantDoorAccessDialogContainer.mapDispatchToProps,
)(UnitGrantDoorAccessDialogContainer)
